export const apiRoutes = {
    checkLoginStatus: 'api/remote/logged/status',
    sendCustomerLogin: 'api/auth/login',
    verifyOtp: 'api/auth/verify-otp',
    sendOtp: 'api/auth/send-otp',
    setPassword: 'api/auth/set-password',
    sendCustomerRegister: 'api/auth/register',
    activateUserAccount: 'api/auth/activate/:userId',

    // Admin APIs
    adminLogin: 'api/auth/adm/login',
    getExternalApiList: 'api/projects/mc/dashboard',
    getSystemApiLogDetail: 'api/logs/moovetshop/sys/api/get/:id/detail',

    getGraphLogData: 'api/logs/get/graph',
    getExternalApiLogDetail: 'api/logs/get/:id/detail',
    getFilterExternalLogToExport: 'api/logs/get/all/filtered',
    getExternalApiLogsPaginated: 'api/logs/get/all/pagination',
    getSystemApiLogsPaginated: 'api/logs/moovetshop/sys/api/get/all/pagination',
    getNotificationLogsList: 'api/logs/notifications/get/all/pagination',
    getNotificationLogsDetails: 'api/logs/notifications/get/:id/detail',

    portalUsersList: 'api/users/all',
    getRegisteredPortalUserDetail: 'api/users/:id',
    toggleAdminRole: 'api/users/toggle/adm/:userId',
    togglePaymentEnabledStatus: 'api/users/toggle/pmt/:userId',
    toggleWorkDayEnabledStatus: 'api/users/toggle/workday/:userId',
    toggleAccountingRoleStatus: 'api/users/toggle/accounting/:userId',
    togglePosRoleStatus: 'api/users/toggle/pos/:userId',
    fetchUserPrivileges: 'api/users/privilege/:userId',
    updateUserPrivileges: 'api/users/privilege/:userId/assign',
    unblockUser: 'api/users/:id/unblock',
    addCards: 'api/cof',
    getCards: 'api/cof',
    deleteCard: 'api/cof/:cardId',
    uploadCardsCSV: 'api/cof/bulk-upload',
    getNickNamesForCards: 'api/cof/generate-nicknames',
    runFinalTestForCards: 'api/cof/validate',
    getTestResults: 'api/cof/validate/test/:testId',
    deleteAccountAndCards: 'api/users/:userId',
    deleteSingleTestResult: 'api/cof/test-result/:singleCardTestId',

    getNVSTestResultsPaginated: 'api/cof/validate',
    exportNVSTestResults: 'api/cof/validate/test-results/export',
    deleteNVSTestResult: 'api/cof/validate/:id',

    //Inventory Cards
    getSampleCSV: 'api/csv-upload/:moduleType',
    uploadInventoryCardsCSV: 'api/inventory-card/bulk-upload',
    saveInventoryCard: 'api/csv-upload',
    getallInventoryCards: 'api/inventory-card',
    getInventoryCardDetails: 'api/inventory-card/:id',
    updateStatusOfInventoryCard: 'api/inventory-card/:id/status/:status',

    //Buisness Disbursement
    getUseCaseDropdown: 'api/payment-type-configuration/get/all',
    getSenderDetails: 'api/sponsor-bank-configuration/use-case/:useCaseType',
    submitBDBTest: 'api/test-send-api',
    getAllTestResults: 'api/test-send-api/get/all',
    exportMoneySendTestResults: 'api/test-send-api/test-results/export',
    restestMoneySend: 'api/test-send-api/retest/:testId',

    // API Credentials Management
    saveNVSAPICredential: 'api/sendnvs/configuration',
    updateNVSAPICredential: 'api/sendnvs/configuration/:id',
    getNVSAPICredentialList: 'api/sendnvs/configuration',
    deleteNVSAPICredential: 'api/sendnvs/configuration/:id',
    getNVSAPICredential: 'api/sendnvs/configuration/:id',
    changeEnableStatusNVSAPICredential: 'api/sendnvs/configuration/enable/:id',

    getPaymentTypeConfigurationList: 'api/payment-type-configuration/get/all',
    savePaymentTypeConfiguration: 'api/payment-type-configuration',
    getPaymentTypeConfiguration: 'api/payment-type-configuration/:id',
    updatePaymentTypeConfiguration: 'api/payment-type-configuration/:id',
    deletePaymentTypeConfiguration: 'api/payment-type-configuration/:id',
    getUseCaseConfiguration: 'api/payment-usecase-type-configuration',

    getSponsorBankConfigurationList: 'api/sponsor-bank-configuration/get/all',
    saveSponsorBankConfiguration: 'api/sponsor-bank-configuration',
    getSponsorBankConfiguration: 'api/sponsor-bank-configuration/:id',
    updateSponsorBankConfiguration: 'api/sponsor-bank-configuration/:id',
    deleteSponsorBankConfiguration: 'api/sponsor-bank-configuration/:id',
    changeSponsorBankConfigurationStatus: 'api/sponsor-bank-configuration/enable/:id',
    setDefaultSponsorBankConfiguration: 'api/sponsor-bank-configuration/default',

    getEnabledCountryList: 'api/country',
    getStateById: 'api/country/get/:id/state',

    // Phase2 APIs
    submitTest: 'api/cof/submit-test',
    saveEvidenceFiles: 'api/test-send-api/test/:testId/evidence-upload',
    quitTransaction: 'api/test-send-api/test/:testId/status/:status',
    getNVSTestResultDetails: 'api/cof/validate/:id',
};
